import axios from "axios";

// Emergent injects REACT_APP_BACKEND_URL. All backend routes live under /api.
const BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kairos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401 && localStorage.getItem("kairos_token")) {
      localStorage.removeItem("kairos_token");
      window.dispatchEvent(new Event("kairos-session-expired"));
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    // FastAPI 422 returns [{loc, msg, type}, ...]
    const first = d[0];
    if (first && typeof first === "object" && typeof first.msg === "string") {
      const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : null;
      return field ? `${field}: ${first.msg}` : first.msg;
    }
    if (d.every((x) => typeof x === "string")) return d.join(" · ");
  }
  if (d && typeof d === "object") {
    if (typeof d.msg === "string") return d.msg;
    if (typeof d.message === "string") return d.message;
  }
  return err?.message || fallback;
}
